import Cookies from "js-cookie";
import { STORAGE_KEY } from "@repo-sapiens/constants";

export const getAccessToken = (): string | null => {
  return (
    Cookies.get(STORAGE_KEY.ACCESS_TOKEN) ||
    localStorage.getItem(STORAGE_KEY.ACCESS_TOKEN)
  );
};

export const getRefreshToken = (): string | null => {
  return (
    Cookies.get(STORAGE_KEY.REFRESH_TOKEN) ||
    localStorage.getItem(STORAGE_KEY.REFRESH_TOKEN)
  );
};

export const saveTokens = (accessToken: string, refreshToken: string) => {
  localStorage.setItem(STORAGE_KEY.ACCESS_TOKEN, accessToken);
  localStorage.setItem(STORAGE_KEY.REFRESH_TOKEN, refreshToken);
  Cookies.set(STORAGE_KEY.ACCESS_TOKEN, accessToken);
  Cookies.set(STORAGE_KEY.REFRESH_TOKEN, refreshToken);
};

export const removeTokens = (): void => {
  Cookies.remove(STORAGE_KEY.REFRESH_TOKEN);
  localStorage.removeItem(STORAGE_KEY.REFRESH_TOKEN);

  Cookies.remove(STORAGE_KEY.ACCESS_TOKEN);
  localStorage.removeItem(STORAGE_KEY.ACCESS_TOKEN);
};

export const getNewToken = async (): Promise<string | undefined> => {
  const accessToken = getAccessToken();

  return accessToken || "";
};
